module.exports = __webpack_public_path__ + "assets/img/1_1648_big.fb8266f9.jpg";